<template>
  <v-card class="mb-5">
    <v-app-bar flat color="white" class="px-4">
      <v-avatar size="40" class="mr-2">
        <img alt="user" :src="$userInfo.image" />
      </v-avatar>

      <v-toolbar-title class="title black--text pl-0">
        {{ (item.publisher || {}).firstName }}
        {{ (item.publisher || {}).lastName }}
        <template v-if="item.type == 'activity'">
          <span class="subtitle-1 grey--text">{{ item.content.text }}</span>
        </template>
        <p class="caption mb-0 grey--text">{{ item.created_at | moment }}</p>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn color="white" icon>
        <v-icon color="grey ">mdi-dots-horizontal</v-icon>
      </v-btn>
    </v-app-bar>

    <v-card-text>
      <template v-if="item.text != '' && item.text != null">
        <p class="mb-0">{{ item.text }}</p>
      </template>
      <template v-if="item.contentType == 'IMAGE'">
        <lightbox
          class="mt-4"
          :items="item.images.map((m) => m.url)"
          :cell="3"
          style="height: 400px; width: 100%"
        ></lightbox>
      </template>
      <template v-if="item.contentType == 'AUDIO' && item.audio">
        <vuetify-audio
          class="mt-4"
          :file="item.audio.url"
          color="#fb91a5"
          :ended="audioFinish"
        ></vuetify-audio>
      </template>
      <template v-if="item.contentType == 'FILE' && item.files">
        <v-card class="link-preview mt-4" elevation="1">
          <v-row align-content="center" no-gutters>
            <v-col cols class="pa-4">
              <p class="body-1 ma-0">
                <a :href="item.files.url" target="_blank">
                  {{ (item.files || {}).title }}
                </a>
              </p>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template v-if="item.type == 'gallery'">
        <lightbox
          class="mt-4"
          :items="item.content"
          :cell="3"
          style="height: 400px; width: 100%"
        ></lightbox>
      </template>
      <template v-else-if="item.contentType === 'YOUTUBE'">
        <vue-plyr class="mt-4">
          <div
            data-plyr-provider="youtube"
            :data-plyr-embed-id="item.youtube.idyoutube"
          ></div>
        </vue-plyr>
      </template>
      <link-preview
        v-else-if="item.contentType === 'LINK'"
        :previewObject="item.link"
      ></link-preview>
      <template v-else-if="item.type == 'activity'">
        <template v-if="item.content.type == 'live'">
          <div>
            <v-img :src="item.content.cover" max-height="240" contain>
              <v-overlay absolute>
                <v-btn icon width="100" height="100">
                  <v-icon size="48">far fa-play</v-icon>
                </v-btn>
              </v-overlay>
            </v-img>
          </div>
        </template>
        <template v-else-if="item.content.type == 'lecture'">
          <v-sheet rounded color="grey lighten-4">
            <div class="pa-4">
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <!-- {{ item.content.title }} -->
                </div>
                <div class="pl-2">
                  <v-avatar color="primary" size="24" class="mr-2">
                    <span class="white--text">5</span> </v-avatar
                  >Part
                </div>
                <v-divider vertical class="mx-2"></v-divider>
                <div>
                  <v-btn text small rounded>
                    <v-icon small left>far fa-eye</v-icon>View
                  </v-btn>
                </div>
              </div>
            </div>
          </v-sheet>
        </template>
      </template>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-row class="text-center" no-gutters>
        <v-col cols="6">
          <v-btn
            block
            text
            :class="liked ? 'text-capitalize blue--text' : 'text-capitalize'"
            v-if="liked"
            @click="unLikePost()"
          >
            <v-icon small left :color="liked ? 'blue' : ''">mdi-thumb-up</v-icon
            >Liked
          </v-btn>
          <v-btn
            block
            text
            class="text-capitalize"
            v-if="!liked"
            @click="likePost()"
          >
            <v-icon small left>mdi-thumb-up-outline</v-icon>Like
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn block text class="text-capitalize">
            <v-icon small left>mdi-comment-outline</v-icon>Comment
          </v-btn></v-col
        >
      </v-row>
    </v-card-actions>
    <v-divider></v-divider>
    <v-expand-transition v-if="item.totalLiked > 0">
      <div>
        <v-card-text>
          <v-icon small left color="blue">mdi-thumb-up</v-icon
          >{{ item.totalLiked || "" }}
        </v-card-text>
        <v-divider></v-divider>
      </div>
    </v-expand-transition>
    <v-expand-transition>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="$userInfo.image"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-text-field
              placeholder="What do you thinking about this ?"
              filled
              rounded
              dense
              hide-details
            >
              <v-file-input
                v-model="imageFiles"
                v-on:change="onFileChange"
                prepend-icon="mdi-image-outline"
                accept="image/x-png, image/jpeg"
                class="pa-0 ma-0"
                hide-input
                color="primary"
                slot="append"
              >
              </v-file-input
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-expand-transition>
    <v-expand-transition>
      <comment-list
        :item="item"
        :increaseTotalCommented="increaseTotalCommented"
      ></comment-list>
    </v-expand-transition>

    <!-- old -->
    <!-- <v-card-text>
      <v-list-item class="pl-0">
        <v-list-item-avatar>
          <v-avatar>
            <img :src="$userInfo.image" />
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            {{ (item.publisher || {}).firstName }}
            {{ (item.publisher || {}).lastName }}
            <template v-if="item.type == 'activity'">
              <span class="grey--text">{{ item.content.text }}</span>
            </template>
          </v-list-item-title>
          <v-list-item-subtitle>{{
            item.created_at | moment
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <template v-if="item.text != '' && item.text != null">
        <div class="body-2" v-html="item.text"></div>
      </template>
      <template v-if="item.type == 'activity'">
        <template v-if="item.content.type == 'live'">
          <div class="d-flex align-center flex-wrap">
            <div>{{ item.content.text }}</div>
            <div class="pl-4"></div>
          </div>
        </template>
        <template v-else-if="item.content.type == 'lecture'"></template>
        <template v-else></template>
      </template>
      <template v-if="item.contentType == 'IMAGE'">
        <lightbox
          class="mt-4"
          :items="item.images.map((m) => m.url)"
          :cell="3"
          style="height: 400px; width: 100%"
        ></lightbox>
      </template>
      <template v-if="item.contentType == 'AUDIO' && item.audio">
        <vuetify-audio
          class="mt-4"
          :file="item.audio.url"
          color="#fb91a5"
          :ended="audioFinish"
        ></vuetify-audio>
      </template>
      <template v-if="item.contentType == 'FILE' && item.files">
        <v-card class="link-preview mt-4" elevation="1">
          <v-row align-content="center" no-gutters>
            <v-col cols class="pa-4">
              <p class="body-1 ma-0">
                <a :href="item.files.url" target="_blank">
                  {{ (item.files || {}).title }}
                </a>
              </p>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template v-if="item.type == 'gallery'">
        <lightbox
          class="mt-4"
          :items="item.content"
          :cell="3"
          style="height: 400px; width: 100%"
        ></lightbox>
      </template>
      <template v-else-if="item.contentType === 'YOUTUBE'">
        <vue-plyr class="mt-4">
          <div
            data-plyr-provider="youtube"
            :data-plyr-embed-id="item.youtube.idyoutube"
          ></div>
        </vue-plyr>
      </template>
      <link-preview
        v-else-if="item.contentType === 'LINK'"
        :previewObject="item.link"
      ></link-preview>
      <template v-else-if="item.type == 'activity'">
        <template v-if="item.content.type == 'live'">
          <div>
            <v-img :src="item.content.cover" max-height="240" contain>
              <v-overlay absolute>
                <v-btn icon width="100" height="100">
                  <v-icon size="48">far fa-play</v-icon>
                </v-btn>
              </v-overlay>
            </v-img>
          </div>
        </template>
        <template v-else-if="item.content.type == 'lecture'">
          <v-sheet rounded color="grey lighten-4">
            <div class="pa-4">
              <div class="d-flex align-center">
                <div class="flex-grow-1"></div>
                <div class="pl-2">
                  <v-avatar color="primary" size="24" class="mr-2">
                    <span class="white--text">5</span> </v-avatar
                  >Part
                </div>
                <v-divider vertical class="mx-2"></v-divider>
                <div>
                  <v-btn text small rounded>
                    <v-icon small left>far fa-eye</v-icon>View
                  </v-btn>
                </div>
              </div>
            </div>
          </v-sheet>
        </template>
      </template>
    </v-card-text>
    <template>
      <v-card-actions>
        <v-btn
          small
          :color="'pink'"
          elevation="0"
          text
          v-if="liked"
          @click="unLikePost()"
        >
          <v-icon small class="mr-1">{{ "fas fa-heart" }}</v-icon>
          {{ item.totalLiked || "" }}
        </v-btn>
        <v-btn small elevation="0" text v-if="!liked" @click="likePost()">
          <v-icon small class="mr-1">{{ "far fa-heart" }}</v-icon>
          {{ item.totalLiked || "" }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="eventShowComment(item)"
          :color="showComment === true ? $buttonColor : ''"
        >
          <v-icon left>far fa-comments-alt</v-icon
          >{{ item.totalCommented || "" }} Comment
        </v-btn>
      </v-card-actions>
    </template>
    <v-expand-transition>
      <comment-list
        v-if="showComment"
        :item="item"
        :increaseTotalCommented="increaseTotalCommented"
      ></comment-list>
    </v-expand-transition> -->
  </v-card>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import CommentList from "./post/CommentList";
import LinkPreview from "./post/LinkPreview";
export default {
  props: ["item"],
  components: {
    "comment-list": CommentList,
    "link-preview": LinkPreview,
    VuetifyAudio: () => import("vuetify-audio"),
  },
  data: () => ({
    showComment: false,
    text: "",
    liked: false,
  }),
  watch: {
    showComment(val) {
      if (val === true) {
        this.getComments();
      }
    },
  },
  mounted() {
    this.liked = this.item.liked;
  },
  filters: {
    moment: function (date) {
      return moment(date).format("D MMMM YYYY, HH:mm:ss");
    },
  },
  methods: {
    increaseTotalCommented() {
      this.item.totalCommented++;
    },
    likePost() {
      Vue.axios
        .post(
          `${this.$store.state.api}/post/like`,
          {
            idpost: this.item._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          this.item.totalLiked++;
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    unLikePost() {
      Vue.axios
        .post(
          `${this.$store.state.api}/post/unlike`,
          {
            idpost: this.item._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          if (this.item.totalLiked - 1 >= 0) {
            this.item.totalLiked--;
          }
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    updateItem(res) {
      if (res.data.status) {
        this.item.liked === res.data.result.liked;
        this.item.likes === res.data.result.likes;
        this.liked = res.data.result.liked;
      }
    },
    comments() {
      return this.item.comments || [];
    },
    getComments() {},
    eventShowComment() {
      this.showComment = !this.showComment;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .lb-grid {
  height: 100% !important;
}
</style>
<style lang="scss">
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line
  .v-input__append-inner {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
